function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cancel_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cancel_svg__a)",
  fillRule: "nonzero",
  d: "M19.42 4.57c.739 0 1.425.365 1.847.94l2.27 3.136v.026l.026.026.08.13c0 .027.026.027.026.053.026.052.026.104.052.182.027.079.027.131 0 .183v15.39c0 1.176-.976 2.143-2.164 2.143H2.164C.976 26.779 0 25.812 0 24.636V9.063c0-.078.026-.13.053-.182 0-.026.026-.026.026-.052l.08-.131.026-.026v-.025l2.27-3.137c.448-.575 1.134-.94 1.872-.94zM4.604 21.22H2.698a.633.633 0 00-.635.63c0 .346.285.628.635.628h1.906c.35 0 .635-.282.635-.629a.632.632 0 00-.635-.629zm1.906-2.516H2.698a.633.633 0 00-.635.629c0 .347.285.63.635.63H6.51c.35 0 .635-.283.635-.63a.633.633 0 00-.635-.629zm7.211-9.156h-3.694V12.3l1.847-.992 1.847.992V9.548zm5.7-2.889h-4.302l.449 1.568h5.093l-1.082-1.49c-.053-.052-.106-.078-.158-.078zm-6.492 0h-2.11l-.449 1.568h3.008l-.449-1.568zm-4.3 0H4.328c-.079 0-.132.027-.158.078l-1.056 1.49H8.18l.449-1.568z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M21.79 0a6.962 6.962 0 100 13.925A6.962 6.962 0 0021.79 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58220",
  d: "M21.79 12.34a5.378 5.378 0 115.378-5.377 5.378 5.378 0 01-5.378 5.378z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M23.687 4.144a.732.732 0 01.918.037.647.647 0 01.032.946L22.791 7l1.846 1.873a.647.647 0 01-.032.946.73.73 0 01-.918.037l-.077-.068-1.783-1.81-1.783 1.81-.077.068a.732.732 0 01-.918-.037.647.647 0 01-.032-.946L20.862 7l-1.845-1.873a.647.647 0 01.032-.946.73.73 0 01.918-.037l.077.068 1.783 1.808 1.783-1.81z"
}));

function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 27
  }, props), _ref, _ref2);
}

export default SvgCancel;